import MainContainer from './MainContainer.js'

const App = () => {
    return(
        <>
            <MainContainer/>
        </>
    )
};

export default App;